<div class="pt-3">
  <mat-tab-group (selectedTabChange)="tabChange($event)" [selectedIndex]="selectedTab" class="dense-6" animationDuration="0">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>display_settings</mat-icon>
        Site Settings
      </ng-template>

      <ng-template matTabContent>
        @defer {
          <app-sitewide></app-sitewide>
        }
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>image</mat-icon>
        Company Management
      </ng-template>

      <ng-template matTabContent>
        @defer {
          <app-companies></app-companies>
        }
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>person</mat-icon>
        User Management
      </ng-template>

      <ng-template matTabContent>
        @defer {
          <app-site-users></app-site-users>
        }
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
